import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import AntTime from '../utils/AntTime';
import { ListManager } from 'react-beautiful-dnd-grid';

import List from 'devextreme-react/list';

import { Template } from 'devextreme-react/core/template';
import AntConfig from '../utils/AntConfig';

import AntLocalization from '../utils/AntLocalization';
import AntCondition from '../utils/AntCondition';
import AntArray from '../utils/AntArray';
import { AntGlobal, AntSession } from '../utils/AntContext';

import AntCardListSkeleton from '../components/AntCardListSkeleton';
import useWidgetFirstLoad from '../components/AntWidgetSkeleton/useWidgetFirstLoad';
import AntCardViewCell from './AntPOSCardViewCell';
import AntCardViewUtil from './AntPOSCardViewUtil';

export default forwardRef(function (props, ref) {
    const appGlobal = AntGlobal();
    // const session = AntSession();
    const location = useLocation();
    const navigate = useNavigate();

    if (props.API && !props.API.entityDisplay) {
        if (appGlobal && appGlobal.appConfig && appGlobal.appConfig.Services) {
            let found = appGlobal.appConfig.Services.find((s) => s.name === props.API.entityName);
            if (found) props.API.init({ entityDisplay: found.display });
        }
    }

    const tableName = props.table ? props.table : props.API ? props.API.entityName : '';

    const config = useMemo(() => {
        let found = appGlobal.tableConfigs?.find((t) => t.tableName === tableName);
        if (found) return found.config;

        let cnf = new AntConfig(appGlobal, tableName);
        cnf.configFields(props.fields);

        if (appGlobal.tableConfigs instanceof Array === false) appGlobal.tableConfigs = [];

        appGlobal.tableConfigs.push({
            tableName: tableName,
            config: cnf
        });
        return cnf;
    }, []);

    const CardUtil = useMemo(() => {
        let util = new AntCardViewUtil(config, tableName);
        return util;
    }, []);

    const [listStates, setListStates] = useState({});

    const [activeItem, setActiveItem] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);

    const [listViewData, setListViewData] = useState([]);
    // Khung xám CHỈ cho lượt tải đầu tiên; các lượt tải lại giữ nguyên thẻ đang hiển thị.
    const [loaded, markLoaded] = useWidgetFirstLoad(true);

    // Đọc trạng thái chọn qua tham chiếu luôn-mới để các hàm gọi lại giữ nguyên danh tính.
    const listStatesRef = useRef({});
    listStatesRef.current = listStates;

    // const activeItem = useRef();
    const listView = useRef();
    const showActionBarTimeout = useRef();
    const isScrolling = useRef(false);
    const isScrollingTimeout = useRef();

    const [shouldRender, setShouldRender] = useState(1);

    const forceRender = useCallback(() => {
        setShouldRender((v) => v + 1);
    }, []);

    const isRender = useMemo(() => shouldRender + (props.shouldRender ? props.shouldRender : 1), [props.shouldRender, shouldRender]);

    const reload = useCallback(() => {
        if (props.dataSource) {
            props.dataSource.pageIndex(0);
            props.dataSource.reload();
            // props.dataSource.pageIndex(0);
            // props.dataSource.reload();
        }
    }, []);

    const onLoadData = useCallback((data, allData) => {
        setListViewData([...allData]);
        markLoaded();
    }, [markLoaded]);

    const onAction = useCallback(
        async (e) => {
            let result;

            if (props.onAction) result = await props.onAction(e);
            setListStates((states) => {
                return {
                    ...states,
                    activeItem: null
                };
            });
            return result;
        },
        [props.onAction]
    );

    const onItemClick = useCallback(
        async (e) => {
            // if (props.showActions === false) {
            if (props.cellActions instanceof Array && e.itemData && e.itemData.actions instanceof Array && e.itemData.actions.length > 0) {
                let act = props.cellActions.find((c) => c.isQuickAction);
                if (act) {
                    let act2 = e.itemData.actions.find((c) => c.name === act.code && c.visible === true);
                    if (act2) {
                        if (props.cellActions.length === 1 && e.itemData.actions.filter((c) => c.visible === true).length === 1)
                            onAction({ actionId: act2.name, action: act2.name, data: e.itemData });
                        return;
                    }
                }
            }
            // }

            if (e.itemData && e.itemData.actions instanceof Array && e.itemData.actions.length > 0) {
                let newActiveItem = e;
                if (listStatesRef.current.activeItem?.itemData?.id === e.itemData.id) newActiveItem = null;

                setListStates((states) => {
                    return {
                        ...states,
                        activeItem: props.showActions !== false ? newActiveItem : undefined,
                        selectedItem: e
                    };
                });
            }

            if (props.onItemClick) props.onItemClick(e.itemData, props.cellActions);
        },
        [onAction, props.cellActions, props.onItemClick, props.showActions, props.rawDataSource]
    );

    const onItemMouseEnter = useCallback(
        async (e) => {
            if (!isScrolling.current) {
                if (e.itemData && e.itemData.actions instanceof Array && e.itemData.actions.length > 0) {
                    if (props.autoShowActions && props.showActions !== false) {
                        if (showActionBarTimeout.current) clearTimeout(showActionBarTimeout.current);
                        showActionBarTimeout.current = setTimeout(
                            (e) => {
                                setListStates((states) => {
                                    return {
                                        ...states,
                                        activeItem: e
                                    };
                                });
                            },
                            200,
                            e
                        );
                    }
                }

                if (props.onItemMouseEnter) {
                    props.onItemMouseEnter(e.itemData);
                }
            }
        },
        [props.onItemMouseEnter, props.autoShowActions, props.showActions, props.rawDataSource]
    );

    // const onItemMouseLeave = useCallback(async (e) => {
    //     // if (!isScrolling.current){
    //     //     console.log('ant-log-x-2 : ',);
    //     //     setListStates((states) => {
    //     //         return {
    //     //             ...states,
    //     //             activeItem: null
    //     //         };
    //     //     });
    //     // }

    //     // console.log('ant-log-onItemMouseLeave : ', e);
    // }, []);

    const onListMouseLeave = useCallback(async (e) => {
        setListStates((states) => {
            return {
                ...states,
                activeItem: null
            };
        });
    }, []);

    // const getCellStyle = useCallback(
    //     (itemData) => {
    //         if (props.cardStyles instanceof Array)
    //             for (let i = 0; i < props.cardStyles.length; i++) {
    //                 const cellStyle = props.cardStyles[i];

    //                 if (cellStyle.when && typeof cellStyle.when === 'object') {
    //                     var isValid = AntCondition.isValid(itemData, {
    //                         when: cellStyle.when,
    //                         whenType: cellStyle.whenType
    //                     });

    //                     if (isValid) return cellStyle;
    //                 }
    //             }
    //         return null;
    //     },
    //     [props.cardStyles]
    // );

    useImperativeHandle(ref, () => ({
        reload: reload,
        onLoadData: onLoadData
    }));
    

    const activeItemId = listStates.activeItem?.itemData ? listStates.activeItem.itemData.id : null;
    const selectedItemId = listStates.selectedItem?.itemData ? listStates.selectedItem.itemData.id : null;

    const itemlRender = useCallback(
        (data, i) => {
            let isActive = data && activeItemId != null && activeItemId === data.id;
            let isSelected = data && selectedItemId != null && selectedItemId === data.id;
            return (
                <AntCardViewCell
                    key={props.table + '-' + i}
                    API={props.API}
                    // maxHeight={baseItemHeight.current ? baseItemHeight.current : 120}
                    table={props.table}
                    item={data}
                    itemIndex={i}
                    isActive={Boolean(isActive)}
                    isSelected={Boolean(isSelected)}
                    cardLayout={props.cardLayout}
                    excludesRowActions={props.excludesRowActions}
                    cardStyles={props.cardStyles}
                    cardClasses={props.cardClasses}
                    cellActions={props.cellActions}
                    showDetail={props.showActionDetail !== false ? props.showDetail : undefined}
                    hightLightSelectedItem={props.hightLightSelectedItem}
                    onAction={onAction}
                    onMouseEnter={onItemMouseEnter}
                    // onMouseLeave={onItemMouseLeave}
                />
            );
        },
        [
            onAction,
            activeItemId,
            selectedItemId,
            onItemMouseEnter,
            // onItemMouseLeave,
            props.table,
            props.API,
            props.showDetail,
            props.cardLayout,
            props.excludesRowActions,
            props.cardStyles,
            props.cardClasses,
            props.cellActions,
            props.hightLightSelectedItem
        ]
    );

    const _itemlRender = useCallback(
        (data, i) => {
            return <div style={{ margin: '10px' }}>{itemlRender(data, i ? i : data.rowIndex)}</div>;
        },
        [itemlRender]
    );

    const onScroll = useCallback((e) => {
        isScrolling.current = true;
        if (isScrollingTimeout.current) clearTimeout(isScrollingTimeout.current);
        isScrollingTimeout.current = setTimeout(() => {
            isScrolling.current = false;
        }, 500);
    }, []);

    // const colCount = props.colCount ? props.colCount : null;

    let bgImage = appGlobal.appAssets.images.errorIcon1;

    const handleDragEnd = useCallback((sourceIndex, destinyIndex) => {
        console.log('ant-log-sourceItem : ', listViewData[sourceIndex]);
        console.log('ant-log-destinyIndex : ', destinyIndex);

        const reorderedItems = [...listViewData];
        const [movedItem] = reorderedItems.splice(sourceIndex, 1);
        reorderedItems.splice(destinyIndex, 0, movedItem);

        setListViewData(reorderedItems);
    }, [listViewData]);


    return (
        <React.Fragment>
            {isRender && (
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        position: 'relative'
                    }}
                >
                    {!loaded && (
                        <AntCardListSkeleton
                            cardLayout={props.cardLayout}
                            cardClasses={props.cardClasses}
                            colCount={props.colCount || 1}
                        />
                    )}
                    {/* <div
                        style={{
                            width: '100%',
                            height: '100%',

                            position: 'absolute',
                            backgroundImage: bgImage ? `url(${bgImage})` : undefined,

                            backgroundRepeat: 'no-repeat',
                            backgroundAttachment: 'fixed',
                            backgroundSize: '100% 100%',
                            filter: 'brightness(0.9)'
                        }}
                        className={`ant-app-backgroundImage`}
                    ></div> */}
                    {/* <div
                        style={{
                            display: listViewData instanceof Array && listViewData.length > 0 ? 'none' : 'flex',
                            justifyContent: 'center',
                            marginTop: 135
                        }}
                    >
                        <img
                            style={{
                                width: '40vh',
                                opacity: 0.5
                            }}
                            src={bgImage}
                        ></img>
                    </div> */}
                    {/* <List
                        ref={listView}
                        {...props}
                        elementAttr={{
                            class: 'ant-pos-card-list'
                        }}
                        loadPanel={{ enabled: false }}
                        indicateLoading={true}
                        noDataText={''}
                        showScrollbar={'onHover'}
                        dataSource={props.dataSource}
                        scrollingEnabled={true}
                        activeStateEnabled={false}
                        focusStateEnabled={false}
                        hoverStateEnabled={false}
                        itemTemplate={'itemlRender'}
                        pageLoadingText={' '}
                        pageLoadMode={'scrollBottom'}
                        width={'100%'}
                        height={'50%'}
                        // itemMargin={0}
                        // useNativeScrolling={true}
                        scrollByContent={true}
                        scrollByThumb={true}
                        // repaintChangesOnly={true}
                        onScroll={onScroll}
                        onItemClick={onItemClick}
                        onContentReady={(e) => {
                            e.element.addEventListener('mouseleave', onListMouseLeave);
                            if (props.onContentReady) props.onContentReady(e);
                            // const width = e.element.clientWidth;
                            // if (width && colCount) {
                            //     let oldBaseWidth = e.component.option('baseItemWidth');
                            //     let itemMargin = e.component.option('itemMargin');
                            //     let baseWidth = parseInt((width - itemMargin * colCount) / colCount);
                            //     if (baseWidth !== oldBaseWidth) {
                            //         baseItemWidth.current = baseWidth;
                            //         forceRender();
                            //     }
                            // }
                        }}
                        // onItemRendered={(e) => {
                        //     let style = getCellStyle(e.itemData);
                        //     if (style && style.backgroundColor) {
                        //         let ele = e.itemElement.querySelector('.ant-card');
                        //         console.log('ant-log-ele : ',ele);
                        //         if (ele) ele.style.backgroundColor = style.backgroundColor;
                        //     }
                        // }}
                    >
                        <Template name={'itemlRender'} render={itemlRender} />
                    </List> */}

                    <ListManager
                        style={{
                            width: '100%',
                            height: '100%',
                            gap: '10px'
                        }}
                        items={listViewData}
                        direction="vertical"
                        maxItems={1}
                        render={_itemlRender}
                        onDragEnd={handleDragEnd}
                    />
                </div>
            )}
        </React.Fragment>
    );
});
